import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 500px) {
    flex-direction: column;
  }
  .left {
    flex-direction: column;
    @media (max-width: 500px) {
      order: 2;
    }
    .date {
      width: 50px;
      height: 14px;
      margin-bottom: 5px;
    }
    .title {
      width: 560px;
      height: 28px;
      margin-bottom: 10px;
      @media (max-width: 906px) {
        width: 250px;
      }
      @media (max-width: 600px) {
        width: 150px;
      }
    }
    .description {
      width: 560px;
      height: 48px;
      @media (max-width: 906px) {
        width: 250px;
      }
      @media (max-width: 600px) {
        width: 150px;
      }
    }
  }
  .right {
    .image {
      width: 300px;
      height: 160px;
      margin-bottom: 10px;
      @media (max-width: 500px) {
        order: 1;
        height: 80px;
        align-items: center;
        width: 80vw;
      }
    }
  }
`;
